import { createI18n } from 'vue-i18n'

import en from './locale/en.json'
import nl from './locale/nl.json'

export const LOCALE_STORAGE_KEY = 'locale'

const getInitialLocale = () => {
  const locale = localStorage.getItem(LOCALE_STORAGE_KEY)

  if (locale === 'en' || locale === 'nl') {
    return locale
  }

  const browserLocale = navigator.language.split('-')[0]

  return browserLocale === 'en' ? 'en' : 'nl'
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'nl',
  messages: {
    en,
    nl,
  },
})
